<div [formGroup]="form" class="tone-selector-form d-flex gap-3">
  <!-- Light tone -->
  <mat-form-field appearance="outline" class="flex-fill">
    <mat-label>Light tone</mat-label>
    <mat-select formControlName="lightTone" id="light-tone-select">
      @for (tone of tonesList; track tone) {
        <mat-option [value]="tone">
          {{ tone }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Primary tone -->
  <mat-form-field appearance="outline" class="flex-fill">
    <mat-label>Primary tone</mat-label>
    <mat-select formControlName="primaryTone" id="primary-tone-select">
      @for (tone of tonesList; track tone) {
        <mat-option [value]="tone">
          {{ tone }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Dark tone -->
  <mat-form-field appearance="outline" class="flex-fill">
    <mat-label>Dark tone</mat-label>
    <mat-select formControlName="darkTone" id="dark-tone-select">
      @for (tone of tonesList; track tone) {
        <mat-option [value]="tone">
          {{ tone }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
